var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.showPageBreak ? 'html2pdf__page-break pagebreak' : 'html2pdf__page-break'})
}
var staticRenderFns = []

export { render, staticRenderFns }